import { borderRadius, typography } from '../KestrixDesignSystem.jsx'
import { colorTokens } from '../tokens/colors.ts'

const warningSoft = colorTokens.semantic.status.warningSoftEmphasis
const errorSoft = colorTokens.semantic.status.errorSoftEmphasis
const successSoft = colorTokens.semantic.status.successSoftEmphasis

export const NOTICE_BANNER_VARIANTS = [
  'info',
  'warning',
  'success',
  'error'
] as const

export type NoticeBannerVariant = (typeof NOTICE_BANNER_VARIANTS)[number]

type NoticeBannerPalette = {
  readonly surface: string
  readonly border: string
  readonly message: string
  readonly icon: string
  readonly action: string
}

/**
 * Per-state palettes for {@link KestrixNoticeBanner} (KDS node 1236:4747).
 *
 * Info uses brand background and a subtle border. Warning, success, and error
 * use the matching `*SoftEmphasis` surface and border tokens.
 */
export const noticeBannerVariantTokens = {
  info: {
    surface: colorTokens.semantic.brand.base.background,
    border: colorTokens.surface.border.subtle,
    message: colorTokens.text.subtextNeutral,
    icon: colorTokens.semantic.brand.primary,
    action: colorTokens.text.linkText
  },
  warning: {
    surface: warningSoft.surface,
    border: warningSoft.border,
    message: colorTokens.text.subtextNeutral,
    icon: colorTokens.semantic.status.warning,
    action: warningSoft.text
  },
  success: {
    surface: successSoft.surface,
    border: successSoft.border,
    message: colorTokens.text.subtextNeutral,
    icon: successSoft.icon,
    action: successSoft.icon
  },
  error: {
    surface: errorSoft.surface,
    border: errorSoft.border,
    message: colorTokens.text.subtextNeutral,
    icon: colorTokens.semantic.status.error,
    action: colorTokens.semantic.status.error
  }
} as const satisfies Record<NoticeBannerVariant, NoticeBannerPalette>

export const noticeBannerTokens = {
  variant: noticeBannerVariantTokens,
  sizing: {
    height: 36,
    paddingX: 16,
    paddingY: 6,
    gap: 12,
    textGap: 8,
    iconFrame: 24,
    icon: 16,
    radius: borderRadius.lg,
    fontSize: typography.body.small.fontSize,
    lineHeight: typography.body.small.lineHeight,
    fontFamily: typography.fontFamily.primary
  }
} as const
